import type { FC } from 'react';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CssBaseline, ThemeProvider } from '@mui/material';
import RTL from 'src/components/RTL';
import SplashScreen from 'src/components/SplashScreen';
import useAuth from 'src/hooks/useAuth';
import useScrollReset from 'src/hooks/useScrollReset';
import useSettings from 'src/hooks/useSettings';
import { createCustomTheme } from 'src/theme';
import Router from 'src/routes';

const App: FC = () => {
  const { settings } = useSettings();
  const auth = useAuth();
  const client = new QueryClient();

  useScrollReset();

  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
  });

  useEffect(() => {
    (window as any).theme = theme;
  }, [theme]);

  return (
    <QueryClientProvider client={client}>
      <ThemeProvider theme={theme}>
        <RTL direction={settings.direction}>
          <CssBaseline />
          <Toaster position="top-center" />
          {auth.isInitialized ? <Router /> : <SplashScreen />}
        </RTL>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
